import * as tslib_1 from "tslib";
import { ElementRef, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { SidenavService } from '@core/services/sidenav.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { merge, Subject } from 'rxjs';
import { debounceTime, switchMap, takeUntil, tap } from 'rxjs/operators';
import { DialogApprovalsEquipmentsDiffComponent } from './dialog/dialog-approvals-diff/dialog-approvals-equipments.component';
import { DialogApprovalsEquipmentsComponent } from './dialog/dialog-approvals-new/dialog-approvals-equipments.component';
import { FilterApprovalsEquipmentsComponent } from './filter/filter-approvals-equipments.component';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
import { ApprovalsEquipmentsService } from './services/approvals-equipments.service';
var ApprovalsEquipmentsComponent = /** @class */ (function () {
    function ApprovalsEquipmentsComponent(sidenavService, fuseTranslationLoaderService, fuseProgressBarService, matDialog, approvalsEquipmentsService) {
        this.sidenavService = sidenavService;
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fuseProgressBarService = fuseProgressBarService;
        this.matDialog = matDialog;
        this.approvalsEquipmentsService = approvalsEquipmentsService;
        this.approvalsEquipmentsReload = new Subject();
        this.filtered = false;
        this.isLoadingResults = true;
        this.resultsLength = 0;
        this.approvals = [];
        this.loading = true;
        this.dataSource = [];
        this.displayedColumns = [
            'number',
            'name',
            'typeName',
            'locationName',
            'status',
            'companyName',
            'createdAt',
            'edit'
        ];
        this.subscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    ApprovalsEquipmentsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.loading = true;
        this.sort.active = 'name';
        this.sort.direction = 'asc';
        merge(this.sort.sortChange, this.paginator.page, this.filterApprovalsEquipmentsComponent.filterChanged.pipe(tap(function () {
            _this.paginator.firstPage();
        })), this.approvalsEquipmentsReload)
            .pipe(debounceTime(500), takeUntil(this.subscriptions), switchMap(function () {
            _this.sort.direction = _this.sort.direction || 'asc';
            var options = {
                orderBy: _this.sort.active + "_" + _this.sort.direction,
                offset: _this.paginator.pageIndex * _this.paginator.pageSize,
                limit: _this.paginator.pageSize
            };
            _this.loading = true;
            return _this.approvalsEquipmentsService.loadData({ where: _this.filterApprovalsEquipmentsComponent.filterChanged.value, options: options });
        }))
            .pipe(takeUntil(this.subscriptions))
            .subscribe(function (result) {
            _this.datatable.nativeElement.scrollTo({
                top: 0,
            });
            _this.approvals = result.items;
            _this.totalCount = result.totalCount;
            _this.filtered = result.filtered;
            _this.loading = false;
        });
    };
    ApprovalsEquipmentsComponent.prototype.reload = function () {
        this.approvalsEquipmentsReload.next();
    };
    ApprovalsEquipmentsComponent.prototype.clearFilters = function () {
        this.filtered = false;
        this.filterApprovalsEquipmentsComponent.clearFilters();
    };
    ApprovalsEquipmentsComponent.prototype.getDialog = function (result) {
        if (result.equipment && result.approval.status === 'pending') {
            return this.matDialog.open(DialogApprovalsEquipmentsDiffComponent, {
                panelClass: ['dialog-approval-equipment-diff'],
                data: {
                    approval: result.approval,
                    equipment: result.equipment
                }
            });
        }
        return this.matDialog.open(DialogApprovalsEquipmentsComponent, {
            panelClass: ['dialog-approval-equipment'],
            data: result.approval
        });
    };
    ApprovalsEquipmentsComponent.prototype.openDialog = function (approval) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.approvalsEquipmentsService.getApprovalAndEquipment({
                                approvalId: approval.id,
                                equipmentQrCode: approval.equipment.qrCode
                            })];
                    case 1:
                        result = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [2 /*return*/, this.getDialog(result)
                                .afterClosed()
                                .toPromise()
                                .then(function (reload) {
                                if (reload) {
                                    _this.reload();
                                }
                            })];
                }
            });
        });
    };
    return ApprovalsEquipmentsComponent;
}());
export { ApprovalsEquipmentsComponent };
